module.exports = __webpack_public_path__ + "img/Osaka-cover.dc5576c3.jpg";